export function pickLang(obj, lang) {
  if (!obj || typeof obj !== "object") return "";
  return obj[lang] || obj.ko || obj.en || Object.values(obj).find(Boolean) || "";
}
